/* type information for all variants & any component-specific prop types or enums go in this file */
export var NotificationTypes;

(function (NotificationTypes) {
  NotificationTypes["Information"] = "Information";
  NotificationTypes["Error"] = "Error";
  NotificationTypes["Success"] = "Success";
  NotificationTypes["Warning"] = "Warning";
  NotificationTypes["Offer"] = "Offer";
  NotificationTypes["Guidance"] = "Guidance";
  NotificationTypes["Moment"] = "Moment";
  NotificationTypes["Event"] = "Event";
})(NotificationTypes || (NotificationTypes = {}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/notification-banner/dist/esm/types.js
// module id = 622
// module chunks = 11